'use client';
export const a11yKeyDownHandler = (event, callback) => {
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
        event.preventDefault();
        callback();
    }
};
//# sourceMappingURL=a11yKeyDownHandler.js.map